import { createStore } from '@stencil/store';
import { SubmittalDoc } from 'common';

export interface SubmittalStoreState {
  submittals: Record<string, SubmittalDoc>;
}

const initialStoreState: SubmittalStoreState = {
  submittals: {},
};

export const { state: submittalState, onChange: submittalStoreOnChange, dispose: disposeSubmittalStore } = createStore<SubmittalStoreState>(initialStoreState);

export const upsertSubmittalsStore = (docs: SubmittalDoc[]) => {
  const next = { ...submittalState.submittals };
  for (const doc of docs) {
    if (doc.deleted_date) {
      delete next[doc._id];
    } else {
      next[doc._id] = doc;
    }
  }
  submittalState.submittals = next;
};

export const getSubmittalByIdFromStore = (id: string): SubmittalDoc | undefined => {
  return submittalState.submittals[id];
};

export const resetSubmittalStore = () => {
  submittalState.submittals = {};
};
